module.exports = __webpack_public_path__ + "static/thumb-empresariales-55ee3e5fcb6c315bacbbd06c684ce029.jpg";